module.exports = __webpack_public_path__ + "static/media/selected.87d9f8aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/coupon/selected.png
// module id = 1896
// module chunks = 6